// Artwork categories surfaced in the main navigation.
// `medium` maps each category to the artwork.medium value stored in Mongo.
// `seoTitle` / `seoDescription` power unique, African-art-focused SEO on each
// category page (/category/:slug).
export const ART_CATEGORIES = [
  {
    slug: "sculptures",
    label: "Sculptures",
    medium: "Sculpture",
    seoTitle: "African Sculptures for Sale — Original Stone & Wood Sculpture",
    seoDescription:
      "Shop original African sculptures for sale — hand-carved stone, wood and bronze works by leading contemporary African sculptors. Direct from the artist on AfricaArtMasters.",
  },
  {
    slug: "paintings",
    label: "Paintings",
    medium: "Painting",
    seoTitle: "African Paintings for Sale — Original Contemporary African Art",
    seoDescription:
      "Browse original African paintings for sale — bold contemporary canvases from painters across Africa. Buy authentic African art direct from the studio on AfricaArtMasters.",
  },
  {
    slug: "photography",
    label: "Photography",
    medium: "Photography",
    seoTitle: "African Photography for Sale — Fine Art Prints by African Photographers",
    seoDescription:
      "Discover fine-art African photography for sale — striking prints capturing the people, land and culture of Africa by contemporary African photographers on AfricaArtMasters.",
  },
  {
    slug: "digital",
    label: "Digital",
    medium: "Digital",
    seoTitle: "African Digital Art for Sale — Contemporary Digital Works",
    seoDescription:
      "Explore contemporary African digital art for sale — original digital and generative works by emerging African artists. Collect authentic African art on AfricaArtMasters.",
  },
  {
    slug: "curios",
    label: "Curios",
    medium: "Curios",
    seoTitle: "African Curios & Collectibles — Handcrafted African Art Objects",
    seoDescription:
      "Shop African curios and collectibles — handcrafted objects, masks and decorative art pieces by African makers. Authentic African art for sale on AfricaArtMasters.",
  },
];

export const categoryBySlug = (slug) =>
  ART_CATEGORIES.find((c) => c.slug === slug);
